<template>
  <button class="btn mr-10 mt-10"
          v-bind:class="{ 'btn-primary': isSelected, 'btn-inactive': !isSelected }"
          v-on:click="$emit('domain-option-clicked', domain.id)"
          v-bind:disabled="loading">
    {{ domain.name }}
  </button>
</template>

<script>
  export default {
    name: 'domain-select-option',

    props: {
      domain: {
        type: Object,
        default: null,
      },
      isSelected: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/evaluations/components/DomainSelectOption.vue